import { sharedPillars } from "../content/shared";

export default function About() {
  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>About CareerMaster</h1>
        <p>
          CareerMaster is an algorithm-first career platform. People build
          verified career profiles; employers post roles and soft-job
          engagements; the system matches people to openings — without a seeker
          job board or employer candidate search.
        </p>
      </header>

      <section className="mkt-section">
        <h2>What we stand for</h2>
        <ul className="mkt-feature-list">
          {sharedPillars.map((p) => (
            <li key={p.title}>
              <h3>{p.title}</h3>
              <p>{p.body}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="mkt-section">
        <p>
          Our goal is to reduce noise for both sides: seekers get relevant
          opportunities when they are ready, and hiring teams review ranked
          matches instead of browsing resumes.
        </p>
      </section>
    </article>
  );
}
